import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { MySpaceOffboarding } from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────

export enum MS_OFFBOARDING_PATH_SEGMENTS {
  ROOT = "offboarding",
}

// ─── Route Definition ─────────────────────────────────────────────────────────

export const myspaceOffboardingRoutes: RouteObject = {
  path: MS_OFFBOARDING_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Offboarding" },
  HydrateFallback: Spinner,
  children: [{ index: true, Component: MySpaceOffboarding }],
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────

export const MS_OFFBOARDING_PATHS = Object.freeze({
  ROOT: addSlashes(MS_OFFBOARDING_PATH_SEGMENTS.ROOT),
});
